import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructions-tamil',
  templateUrl: '../views/instructions.tamil.component.html',
  styleUrls: ['../views/staff.component.css','../../../css/instructions.component.css', '../../../css/paper-sets.component.css', '../../setting/setting.component.css']

})
export class InstructionsTamilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/components/instructions-tamil.component.ts